import styled from "styled-components";
import { createContext, useState, useEffect } from "react";
import { listenToTenMostRecentStories } from "../Firebase";
import { StoryData } from "../Types/Database/StoriesData";

export const StoriesContext = createContext<StoriesContext>({
  stories: [],
  getTenMoreStories: () => {},
});

export default function StoriesContextProvider(props: Props) {
  const [stories, setStories] = useState<StoryData[]>([]);
  const [numberOfStoriesToGet, setNumberOfStoriesToGet] = useState<number>(10);

  useEffect(() => {
    const unsubscribeFromStories = listenToTenMostRecentStories(
      (storiesFromServer) => {
        setStories([...storiesFromServer]);
      },
      numberOfStoriesToGet
    );

    return () => {
      unsubscribeFromStories();
    };
  }, [numberOfStoriesToGet]);

  function getTenMoreStories() {
    setNumberOfStoriesToGet(numberOfStoriesToGet + 10);
  }

  return (
    <StoriesContext.Provider
      value={{
        getTenMoreStories: getTenMoreStories,
        stories: stories,
      }}
    >
      {props.children}
    </StoriesContext.Provider>
  );
}

interface StoriesContext {
  stories: StoryData[];
  getTenMoreStories: () => void;
}

interface Props {
  children: React.ReactNode;
}
